import React, { useState } from 'react'
import { Query, Mutation } from 'react-apollo'
import { useQuery } from '@apollo/react-hooks'
import _ from 'lodash'
import { Div, P, Loading } from 'konsys-ui'
import { message } from 'antd'
import { CREATE_DRIVER, UPDATE_FUEL_ORDER } from '../../../constants/graphql/mutation'
import detailType from '../util-functions'
import { MYINFO } from '../../../constants/graph/query'
import { detailMode, status } from '../constants'
import { FUEL_ORDER_INFO } from '../../../constants/graphql/query'
import { ActionBar } from '../../../components/filling-order-components'
import history from '../../../history'
import { MobileFuelList } from '../list/mobile'

const Index = ({ props }) => {
  const {
    data: myInfo, loading: myInfoLoading,
  } = useQuery(MYINFO)
  if (myInfoLoading || _.isEmpty(myInfo)) return <Loading center='true' />
  if (myInfo.myInfo.Roles[0].id === 11) return <MobileFuelList props={props}/>
  return <FuelDetail props={props}/>
}

const FuelDetail = ({ props }) => {
  const isAddMode = props.match.params.mode.toUpperCase() === detailMode.ADD
  const isUpdateMode = props.match.params.mode.toUpperCase() === detailMode.EDIT
  const isViewMode = props.match.params.mode.toUpperCase() === detailMode.VIEW

  if (isAddMode) {
    history.push('/fill-order')
    return null
  }

  const [mutationVariables, setMutationVariables] = useState({})

  // TODO: TOP use const instead
  let onChangeHandler = (id, value) => {
    if (id === 'gasstationCode') {
      setMutationVariables({
        ...mutationVariables,
        [id]: value.id,
        gasName: value.name,
        gasCompany: value.company,
      })
    } else {
      setMutationVariables({
        ...mutationVariables,
        [id]: value,
      })
    }
  }

  let fuelInfo = []

  return (
    <Query
      query={FUEL_ORDER_INFO}
      variables={{
        id: props.match.params.id,
      }}
    >
      {
        ({
          data: fuel, error: fuelError, loading: fuelLoading, refetch,
        }) => {
          if (fuelLoading && _.isEmpty(fuel)) return <Loading center='true' />
          if (fuelError) return <P>เกิดข้อผิดพลาด</P>
          if (isUpdateMode && !_.includes([status.WAITING, status.EXPIRED, status.PRINTED, status.FILLED, status.BILLED, status.CANCELLED], fuel.FuelOrderInfo.status)) {
            message.error('ไม่สามารถแก้ไขใบเบิกน้ำมันได้เนื่องจากสถานะ')
            history.push('/fill-order')
          }
          fuelInfo = fuel.FuelOrderInfo
          fuelInfo = {
            ...fuel.FuelOrderInfo,
            ...fuel.FuelOrderInfo.ShippingOrder,
            ...fuel.FuelOrderInfo.ShippingOrder.Job,
            jobVolume: fuel.FuelOrderInfo.ShippingOrder.Job.volumn,
            jobNumber: fuel.FuelOrderInfo.ShippingOrder.Job.number,
            jobDealType: fuel.FuelOrderInfo.ShippingOrder.Job.dealType,
            customerCompanyName: fuel.FuelOrderInfo.ShippingOrder.Job.Customer.companyName,
            customerCompanyNameId: fuel.FuelOrderInfo.ShippingOrder.Job.Customer.companyId,
            customerBranch: fuel.FuelOrderInfo.ShippingOrder.Job.Customer.branch,
            startLocation: fuel.FuelOrderInfo.ShippingOrder.startDestinationLocation.name,
            endLocation: fuel.FuelOrderInfo.ShippingOrder.endDestinationLocation.name,
            startLocationId: fuel.FuelOrderInfo.ShippingOrder.startDestinationLocation.id,
            endLocationId: fuel.FuelOrderInfo.ShippingOrder.endDestinationLocation.id,
            startLocationBranch: fuel.FuelOrderInfo.ShippingOrder.startDestinationLocation.branch,
            endLocationBranch: fuel.FuelOrderInfo.ShippingOrder.endDestinationLocation.branch,
            ...fuel.FuelOrderInfo.ShippingOrder.Truck,
            truckType: fuel.FuelOrderInfo.ShippingOrder.Truck.type.nameTh,
            truckCategory: fuel.FuelOrderInfo.ShippingOrder.TruckOwner.type,
            truckOwner: fuel.FuelOrderInfo.ShippingOrder.TruckOwner.nameTh,
            truckDriver: fuel.FuelOrderInfo.ShippingOrder.Truck.driver.fullname,
            shippingDriver: fuel.FuelOrderInfo.ShippingOrder.Driver.fullname,
            truckDriverId: fuel.FuelOrderInfo.ShippingOrder.Truck.driver.employeeId,
            shippingDriverId: fuel.FuelOrderInfo.ShippingOrder.Driver.employeeId,
            gasstationCode: fuel.FuelOrderInfo.Gasstation.code,
            gasstationName: fuel.FuelOrderInfo.Gasstation.name,
            gasstationCompany: fuel.FuelOrderInfo.Gasstation.company,
            images: fuel.FuelOrderInfo.files,
            type: fuel.FuelOrderInfo.ShippingOrder.Job.Customer.TypeOfCharge.name,
            compensation: !_.isNull(fuel.FuelOrderInfo.fuelcompensation) && fuel.FuelOrderInfo.fuelcompensation.totalDeduct,
            totalFuelamountCompensation: fuel.FuelOrderInfo.ShippingOrder.Driver.totalFuelamountCompensation,
          }
          onChangeHandler = (id, value) => {
            switch (id) {
              case 'specialReason':
                setMutationVariables({
                  gasstationId: fuel.FuelOrderInfo.Gasstation.id,
                  pricePerLitre: fuel.FuelOrderInfo.pricePerLitre,
                  kmPerLitre: fuel.FuelOrderInfo.kmPerLitre,
                  totalAmount: fuel.FuelOrderInfo.totalAmount,
                  fuelType: fuel.FuelOrderInfo.fuelType,
                  gasName: fuel.FuelOrderInfo.Gasstation.name,
                  gasCode: fuel.FuelOrderInfo.Gasstation.code,
                  gasCompany: fuel.FuelOrderInfo.Gasstation.company,
                  ...mutationVariables,
                  [id]: value,
                  specialReasonOther: '',
                })
                break
              case 'gasstationCode':
                setMutationVariables({
                  pricePerLitre: fuel.FuelOrderInfo.pricePerLitre,
                  kmPerLitre: fuel.FuelOrderInfo.kmPerLitre,
                  totalAmount: fuel.FuelOrderInfo.totalAmount,
                  fuelType: fuel.FuelOrderInfo.fuelType,
                  ...mutationVariables,
                  gasstationId: value.id,
                  gasName: value.name,
                  gasCode: value.code,
                  gasCompany: value.company,
                })
                break
              default:
                setMutationVariables({
                  gasstationId: fuel.FuelOrderInfo.Gasstation.id,
                  pricePerLitre: fuel.FuelOrderInfo.pricePerLitre,
                  kmPerLitre: fuel.FuelOrderInfo.kmPerLitre,
                  totalAmount: fuel.FuelOrderInfo.totalAmount,
                  fuelType: fuel.FuelOrderInfo.fuelType,
                  gasName: fuel.FuelOrderInfo.Gasstation.name,
                  gasCode: fuel.FuelOrderInfo.Gasstation.code,
                  gasCompany: fuel.FuelOrderInfo.Gasstation.company,
                  ...mutationVariables,
                  [id]: value,
                })
            }
          }
          return (
            <Div display='flex' flexDirection='column'>
              {/* ================== Data section ================== */}
                  <Div>
                    {
                      detailType(props.match.params, fuelInfo, onChangeHandler, mutationVariables) // argument mode
                    }
                    {/* ================== Footer section ================== */}
                    {
                      !isViewMode
                        ? <Mutation
                            mutation={isAddMode ? CREATE_DRIVER : UPDATE_FUEL_ORDER}
                          >{(doAction, { loading: mutationLoading }) => (
                            <ActionBar
                              status={fuel.FuelOrderInfo.status}
                              loading={mutationLoading}
                              disabled={_.isUndefined(mutationVariables.gasstationId)
                                || _.isUndefined(mutationVariables.pricePerLitre) || _.isNaN(mutationVariables.pricePerLitre)
                                || _.isUndefined(mutationVariables.kmPerLitre) || _.isNaN(mutationVariables.kmPerLitre)
                                || _.isUndefined(mutationVariables.totalAmount) || _.isNaN(mutationVariables.totalAmount)
                                || _.isUndefined(mutationVariables.fuelType) || _.isEmpty(mutationVariables.fuelType)}
                              isAddMode={isAddMode}
                              isViewMode={isViewMode}
                              doAction={doAction}
                              mutationVariables={{ ...mutationVariables }}
                              props={props}
                              volumeNumber={fuel.FuelOrderInfo.ShippingOrder}
                            />
                          )}
                          </Mutation>
                        : <ActionBar
                            status={fuel.FuelOrderInfo.status}
                            disabled={fuel.FuelOrderInfo.status === 'FILLED'}
                            isAddMode={isAddMode}
                            isViewMode={isViewMode}
                            props={props}
                            refetch={refetch}
                            volumeNumber={fuel.FuelOrderInfo.ShippingOrder}
                          />
                    }
                  </Div>
            </Div>
          )
        }}
    </Query>
  )
}

export default Index
export { Index }
